module.exports = __webpack_public_path__ + "img/3_37.eb2a4e6d.png";